/**
 * engine API
 * engine API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { FieldConfig } from '../model/fieldConfig';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class EnginePublicLandingPageService {

    protected basePath = 'https://dmp.airiane.com/services/engine';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * addData
     *
     * @param body body
     * @param id id
     * @param xDataStoreID X-DataStoreID
     * @param X_PARTNER_ID X-PARTNER-ID
     * @param lang lang
     * @param v v
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
     public addDataUsingPOST(body: any, id: string, xDataStoreID?: string, X_PARTNER_ID?: string, lang?: string, v?: number, observe?: 'body', reportProgress?: boolean): Observable<string>;
     public addDataUsingPOST(body: any, id: string, xDataStoreID?: string, X_PARTNER_ID?: string, lang?: string, v?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
     public addDataUsingPOST(body: any, id: string, xDataStoreID?: string, X_PARTNER_ID?: string, lang?: string, v?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
     public addDataUsingPOST(body: any, id: string, xDataStoreID?: string, X_PARTNER_ID?: string, lang?: string, v?: number, observe: any = 'body', reportProgress = false ): Observable<any> {

         if (body === null || body === undefined) {
             throw new Error('Required parameter body was null or undefined when calling addDataUsingPOST.');
         }

         if (id === null || id === undefined) {
             throw new Error('Required parameter id was null or undefined when calling addDataUsingPOST.');
         }


         let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
         if (lang !== undefined && lang !== null) {
             queryParameters = queryParameters.set('lang', <any>lang);
         }
         if (v !== undefined && v !== null) {
             queryParameters = queryParameters.set('v', <any>v);
         }

         let headers = this.defaultHeaders;
         if (xDataStoreID !== undefined && xDataStoreID !== null) {
             headers = headers.set('X-DataStoreID', String(xDataStoreID));
         }
         if (X_PARTNER_ID !== undefined && X_PARTNER_ID !== null) {
             headers = headers.set('X-PARTNER-ID', String(X_PARTNER_ID));
         }

         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'application/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected != undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
             'application/json'
         ];
         const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
         if (httpContentTypeSelected != undefined) {
             headers = headers.set('Content-Type', httpContentTypeSelected);
         }

         return this.httpClient.post<string>(`${this.basePath}/api/public/v1/landingpage/${encodeURIComponent(String(id))}/data`,
             body,
             {
                 params: queryParameters,
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

    /**
     * getId
     *
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getIdUsingGET(id: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public getIdUsingGET(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public getIdUsingGET(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public getIdUsingGET(id: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getIdUsingGET.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<boolean>(`${this.basePath}/api/public/v1/landingpage/${encodeURIComponent(String(id))}/data`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getIhmData
     *
     * @param xDataStoreID X-DataStoreID
     * @param action action
     * @param codeLandingpage codeLandingpage
     * @param lang lang
     * @param param param
     * @param token token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getIhmDataUsingGET(xDataStoreID: string, action: string, codeLandingpage: string, lang?: string, param?: Array<string>, token?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public getIhmDataUsingGET(xDataStoreID: string, action: string, codeLandingpage: string, lang?: string, param?: Array<string>, token?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public getIhmDataUsingGET(xDataStoreID: string, action: string, codeLandingpage: string, lang?: string, param?: Array<string>, token?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public getIhmDataUsingGET(xDataStoreID: string, action: string, codeLandingpage: string, lang?: string, param?: Array<string>, token?: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getIhmDataUsingGET.');
        }

        if (action === null || action === undefined) {
            throw new Error('Required parameter action was null or undefined when calling getIhmDataUsingGET.');
        }

        if (codeLandingpage === null || codeLandingpage === undefined) {
            throw new Error('Required parameter codeLandingpage was null or undefined when calling getIhmDataUsingGET.');
        }




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (action !== undefined && action !== null) {
            queryParameters = queryParameters.set('action', <any>action);
        }
        if (codeLandingpage !== undefined && codeLandingpage !== null) {
            queryParameters = queryParameters.set('codeLandingpage', <any>codeLandingpage);
        }
        if (lang !== undefined && lang !== null) {
            queryParameters = queryParameters.set('lang', <any>lang);
        }
        if (param) {
            param.forEach((element) => {
                queryParameters = queryParameters.append('param', <any>element);
            })
        }
        if (token !== undefined && token !== null) {
            queryParameters = queryParameters.set('token', <any>token);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<any>(`${this.basePath}/api/public/v1/landingpage/ihm/data`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getLandingPage
     *
     * @param id id
     * @param lang lang
     * @param xDataStoreID X-DataStoreID
     * @param X_PARTNER_ID X-PARTNER-ID
     * @param v v
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
     public getLandingPageUsingGET(id: string, lang: string, xDataStoreID?: string, X_PARTNER_ID?: string, v?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<FieldConfig>>;
     public getLandingPageUsingGET(id: string, lang: string, xDataStoreID?: string, X_PARTNER_ID?: string, v?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<FieldConfig>>>;
     public getLandingPageUsingGET(id: string, lang: string, xDataStoreID?: string, X_PARTNER_ID?: string, v?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<FieldConfig>>>;
     public getLandingPageUsingGET(id: string, lang: string, xDataStoreID?: string, X_PARTNER_ID?: string, v?: number, observe: any = 'body', reportProgress = false ): Observable<any> {

         if (id === null || id === undefined) {
             throw new Error('Required parameter id was null or undefined when calling getLandingPageUsingGET.');
         }

         if (lang === null || lang === undefined) {
             throw new Error('Required parameter lang was null or undefined when calling getLandingPageUsingGET.');
         }


         let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
         if (v !== undefined && v !== null) {
             queryParameters = queryParameters.set('v', <any>v);
         }

         let headers = this.defaultHeaders;
         if (xDataStoreID !== undefined && xDataStoreID !== null) {
             headers = headers.set('X-DataStoreID', String(xDataStoreID));
         }
         if (X_PARTNER_ID !== undefined && X_PARTNER_ID !== null) {
             headers = headers.set('X-PARTNER-ID', String(X_PARTNER_ID));
         }

         // to determine the Accept header
         const httpHeaderAccepts: string[] = [
             'application/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected != undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
         ];

         return this.httpClient.get<Array<FieldConfig>>(`${this.basePath}/api/public/v1/landingpage/${encodeURIComponent(String(id))}/${encodeURIComponent(String(lang))}`,
             {
                 params: queryParameters,
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

    /**
     * postIhmData
     *
     * @param xDataStoreID X-DataStoreID
     * @param action action
     * @param codeLandingpage codeLandingpage
     * @param data data
     * @param lang lang
     * @param param param
     * @param token token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postIhmDataUsingPOST(xDataStoreID: string, action: string, codeLandingpage: string, data: any, lang?: string, param?: Array<string>, token?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public postIhmDataUsingPOST(xDataStoreID: string, action: string, codeLandingpage: string, data: any, lang?: string, param?: Array<string>, token?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public postIhmDataUsingPOST(xDataStoreID: string, action: string, codeLandingpage: string, data: any, lang?: string, param?: Array<string>, token?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public postIhmDataUsingPOST(xDataStoreID: string, action: string, codeLandingpage: string, data: any, lang?: string, param?: Array<string>, token?: string, observe: any = 'body', reportProgress = false ): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling postIhmDataUsingPOST.');
        }

        if (action === null || action === undefined) {
            throw new Error('Required parameter action was null or undefined when calling postIhmDataUsingPOST.');
        }

        if (codeLandingpage === null || codeLandingpage === undefined) {
            throw new Error('Required parameter codeLandingpage was null or undefined when calling postIhmDataUsingPOST.');
        }

        if (data === null || data === undefined) {
            throw new Error('Required parameter data was null or undefined when calling postIhmDataUsingPOST.');
        }




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (action !== undefined && action !== null) {
            queryParameters = queryParameters.set('action', <any>action);
        }
        if (codeLandingpage !== undefined && codeLandingpage !== null) {
            queryParameters = queryParameters.set('codeLandingpage', <any>codeLandingpage);
        }
        if (lang !== undefined && lang !== null) {
            queryParameters = queryParameters.set('lang', <any>lang);
        }
        if (param) {
            param.forEach((element) => {
                queryParameters = queryParameters.append('param', <any>element);
            })
        }
        if (token !== undefined && token !== null) {
            queryParameters = queryParameters.set('token', <any>token);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/api/public/v1/landingpage/ihm/data`,
            data,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
